import {AbstractReactComponent, DetailValue, ff, form} from 'mc/lib';
import {formatCurrency} from 'mc/lib/utils/commons';
import * as subjektFormatter from 'mc/lib/utils/subjektFormatter';
import React from 'react';
import {connect} from 'react-redux';
import {Col, Row} from 'reactstrap';
import {reduxForm} from 'redux-form';
import ParovaniPlatebApi from '../api/gen/pohledavky/ParovaniPlatebApi';
import FakPripadFulltextField from '../components/FakPripadFulltextField';

const Form = form.Form;
const FormActions = form.FormActions;
const FormBody = form.FormBody;

const validate = (values, props) => {
    const errors = {};
    const {pripad, castka} = values;

    if (!pripad) {
        errors.pripad = 'Musí být vybrán existující případ.';
    }

    if (castka == null || castka === '') {
        errors.castka = 'Pole je povinné';
    } else if ((castka - props.zbyva) > 0) {
        errors.castka = 'Částka nesmí být vyšší než zbývající částka vyrovnání.';
    } else if (castka <= 0 && props.zbyva > 0) {
        errors.castka = 'Částka musí být kladné číslo.';
    } else if (castka >= 0 && props.zbyva < 0) {
        errors.castka = 'Částka musí být záporné číslo.';
    }

    return errors;
};

/**
 * Formulář pro filtr plateb pro párování.
 */
class PridaniVyrovnaniForm extends AbstractReactComponent {

    static formName = 'PridaniVyrovnaniForm';

    static propTypes = {
        kodTypPripad: React.PropTypes.string, // kód typu případu, za který chceme zafiltrovat případy vyhledané fulltextem
        zbyva: React.PropTypes.number.isRequired, // maximální částka kterou lze vyrovnat
        submitLabel: React.PropTypes.string,
    };

    static defaultProps = {
        submitLabel: 'Přidat',
    };

    state = {
        pripad: null,
    };

    handleFilterSuggestions = (fulltext) => {
        const {kodTypPripad} = this.props;
        return ParovaniPlatebApi.findPripadFulltext(fulltext, kodTypPripad);
    };

    handlePripadSelect = pripad => {
        this.setState({pripad: pripad})
    };

    render() {
        const {handleSubmit, submitting, onClose, zbyva, submitLabel} = this.props;
        const {pripad} = this.state;

        const commonsFulltext = {
            labelClass: {xs: 0},
            disabled: submitting
        };
        const commonsInputFulltext = {
            inputClass: {xs: 12},
            disabled: submitting
        };

        const commons = {
            labelClass: {xs: 12, sm: 6},
            disabled: submitting
        };
        const commonsInput = {
            inputClass: {xs: 12, sm: 6},
            disabled: submitting
        };

        return (
            <Form onSubmit={handleSubmit} horizontal>
                <FormBody>
                    <form.BaseField
                        required
                        componentClass={FakPripadFulltextField}
                        label=""
                        name={'pripad'}
                        onFilterSuggestions={this.handleFilterSuggestions}
                        onChange={this.handlePripadSelect}
                        {...commonsFulltext}
                        {...commonsInputFulltext}
                    />
                    {pripad && <Row>
                        <Col xs={4}>
                            <DetailValue label="Variabilní symbol">{pripad.vs}</DetailValue>
                        </Col>
                        <Col xs={4}>
                            <DetailValue label="Specifický symbol">{pripad.ss}</DetailValue>
                        </Col>
                        <Col xs={4}>
                            <DetailValue label="Zbývá uhradit">{formatCurrency(pripad.predepsano - pripad.uhrazenoFaktury)}</DetailValue>
                        </Col>
                    </Row>}
                    {pripad && pripad.subjekt && <Row>
                        <Col xs={12}>
                            <DetailValue label="Subjekt">{subjektFormatter.getUplnaIdentifikace(pripad.subjekt)}</DetailValue>
                        </Col>
                    </Row>}

                    <Row className="mt-1">
                        <Col xs={8}>
                            <ff.Currency label="Částka vyrovnání" name="castka" {...commons} {...commonsInput}/>
                        </Col>
                        <Col xs={4} className="row form-group col-form-label">
                            <div>Zbývá {formatCurrency(zbyva)}</div>
                        </Col>
                    </Row>
                </FormBody>
                <FormActions onClose={onClose} disabled={submitting} submitButton={submitLabel} cancelButton />
            </Form>
        );
    }
}

const reduxFormObj = reduxForm({
    form: PridaniVyrovnaniForm.formName,
    validate: validate,
})(PridaniVyrovnaniForm);

export default connect()(reduxFormObj);
